import React, { useEffect, useMemo } from 'react'
import { TABLET_SIZE } from '../../../../core/constants/common'
import CurrentUserPlan from './CurrentUserPlan'
import { useGetUserPackage } from '../../services'
import { useWindowSize } from '../../../../modules/Dashboard'
import RCurrentPlan from './RCurrentPlan'
import { getRemainingDays } from './helper'
import { usePredictContext } from '../../../analyze/context/PredictContextProvider'

const CurrentPlan = () => {
    const { width } = useWindowSize()
    const { setIsLocked } = usePredictContext()
    const { data: currentPlan, isLoading } = useGetUserPackage()

    const isPlanValid = useMemo(() => {
        return Boolean(
            currentPlan?.packageData &&
            getRemainingDays(currentPlan?.packageData?.expiresAt) > 0 &&
            currentPlan?.packageData?.maxUse - currentPlan?.packageData?.used > 0
        )
    }, [currentPlan])

    useEffect(() => {
        setIsLocked(!isPlanValid)
    }, [isPlanValid, setIsLocked])

    return (
        <>
            {
                width >= TABLET_SIZE ?
                    <CurrentUserPlan data={currentPlan} loading={isLoading} isPlanValid={isPlanValid} /> :
                    <RCurrentPlan data={currentPlan} loading={isLoading} isPlanValid={isPlanValid} />
            }
        </>
    )
}

export default CurrentPlan